const defaultColumns = [
  {
    Header: 'Title',
    accessor: 'title'
  },
  {
    Header: 'Pillar',
    accessor: 'pillar'
  },
  {
    Header: 'Spend',
    accessor: 'totalContentDebit'
  },
  {
    Header: 'SEO Traffic',
    accessor: 'totalOrganicSearchTraffic'
  },
  {
    Header: 'SEO Traffic Value',
    accessor: 'totalOrganicSearchTrafficValue'
  }
];

export default defaultColumns;



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/tableConfig.js